import PaymentRequestsTableColumnDate from './index.vue'
export default PaymentRequestsTableColumnDate